export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-categories`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-categories/${ID}`;
}

export function FormsIndex(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-categories/${ID}/forms`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/form-categories`;
}

export function PublicShow(publicID: string): string {
	return `/v1/form-categories/public/${publicID}`;
}

export function PublicShowV2(publicID: string): string {
	return `/v1/form-categories/public-v2/${publicID}`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-categories/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/form-categories/${ID}`;
}

